import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Swal from 'sweetalert2';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../components/ModalsCommonFunctions';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../../components/Navigation';
import Pagination from '../../components/Pagination';

const InstituteLessonMaster = () => {
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()
    let instituteMasterId = localStorage.getItem("instituteMasterId")

    const initialFormState = {
        instituteMasterId: instituteMasterId,
        instituteSyllabusStructureMasterId: '',
        instituteSubjectMasterId: '',
        instituteLessonName: ['']
    }
    const [syllabusList, setSyllabusList] = useState([])
    const [subjectList, setSubjectList] = useState([])
    const [lessonData, setLessonData] = useState(initialFormState)
    const [lessonList, setLessonList] = useState([])
    const [editId, setEditId] = useState(null)

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);

    const [syllabusNameSort, setSyllabusNameSort] = useState(null);
    const [subjectNameSort, setSubjectNameSort] = useState(null);
    const [lessonNameSort, setLessonNameSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["instituteSyllabusStructureMasterDetails.instituteSyllabusStructureName", "instituteSubjectMasterDetails.subjectName", "instituteLessonName"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getSyllabusList();
    }, []);

    useEffect(() => {
        if (lessonData.instituteSyllabusStructureMasterId.length !== 0 && lessonData.instituteSubjectMasterId !== '') {
            getLessonList();
        }
    }, [lessonData.instituteSubjectMasterId]);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getLessonList();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            setLessonList(await searchArray("I", getApiUrl(), searchKeys, searchValue.trim()))
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(lessonList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(lessonList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > lessonList.length) {
            endIndex = lessonList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(lessonList.slice(startIndex, endIndex));
    }, [lessonList, currPage, itemsPerPage]);

    const getApiUrl = () => {
        let apiUrl = `/get-institute-lesson-master?instituteMasterId=${instituteMasterId}&`;
        if (lessonData.instituteSyllabusStructureMasterId) {
            apiUrl += `instituteSyllabusStructureMasterId=${lessonData.instituteSyllabusStructureMasterId}&`;
        }

        if (lessonData.instituteSubjectMasterId) {
            apiUrl += `instituteSubjectMasterId=${lessonData.instituteSubjectMasterId}&`;
        }

        apiUrl = apiUrl.replace(/&$/, '');
        return apiUrl;
    }

    const getLessonList = async () => {
        try {
            const response = await authorizedAxiosInstitute.get(getApiUrl());
            setLessonList(response.data.result);
        } catch (error) {
            setLessonList([]);
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        }
    }

    const getSyllabusList = () => {
        const apiUrlForSyllabus = `get-institute-syllabus-structure?instituteMasterId=${instituteMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrlForSyllabus)
            .then(response => {
                setSyllabusList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleSyllabusChange = (e) => {
        setLessonData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                instituteSubjectMasterId: ''
            }
        })
        const apiUrl = `get-institute-syllabus-structure-Wise-institute-subjects?id=${e.target.value}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
            .then(response => {
                setSubjectList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleInputChange = (e, index) => {
        setLessonData((prevData) => {
            if (e.target.name === 'instituteLessonName') {
                const updatedLessonName = [...prevData.instituteLessonName];
                updatedLessonName[index] = e.target.value;
                return {
                    ...prevData,
                    instituteLessonName: updatedLessonName,
                };
            } else {
                return {
                    ...prevData,
                    [e.target.name]: e.target.value
                }
            }
        })
    }

    const handleAddLesson = () => {
        setLessonData((prevData) => ({
            ...prevData,
            instituteLessonName: [...prevData.instituteLessonName, ''],
        }));
    };

    const handleRemoveLesson = (index) => {
        setLessonData((prevData) => {
            const updatedLessonName = [...prevData.instituteLessonName];
            // Remove the element at the specified index
            updatedLessonName.splice(index, 1);
            return {
                ...prevData,
                instituteLessonName: updatedLessonName,
            }
        });
    };

    //error
    const initialErrorState = {

    }
    const [error, setError] = useState(initialErrorState)
    const validateForm = () => {
        const noErrors = Object.values(error).every((error) => error === '');

        const allValuesValid = Object.entries(lessonData).every(([key, value]) => {
            if (key === 'instituteLessonName' && Array.isArray(value)) {
                return value.every(lesson => typeof lesson === 'string' && lesson.trim() !== '');
            } else {
                return typeof value === 'string' && value.trim() !== '';
            }
        });

        return noErrors && allValuesValid;
    };

    useEffect(() => {
        if (!Object.values(error).every((error) => error === '')) {
            for (const [key, value] of Object.entries(lessonData)) {
                if (key === "instituteLessonName") {
                    for (const lesson of lessonData.instituteLessonName) {
                        if (lesson == '' || lesson.length == 0) {
                            setError((prevData) => ({
                                ...prevData,
                                instituteLessonName: 'This field is required.',
                            }));
                            break;
                        } else {
                            setError((prevData) => {
                                return {
                                    ...prevData,
                                    [key]: '',
                                }
                            });
                        }
                    }
                } else if (value == '' || value.length == 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }, [lessonData])

    const addLesson = async () => {
        if (validateForm()) {
            try {
                setLoading(true);
                const apiUrl = `/add-institute-lesson-master`;
                const response = await authorizedAxiosInstitute.post(apiUrl, lessonData);
                await getLessonList();
                setLessonData((prevData) => {
                    return {
                        ...prevData,
                        instituteLessonName: [''],
                    };
                })

                setSaveId(response.data.result[0].id);
                setSyllabusNameSort(null);
                setSubjectNameSort(null);
                setLessonNameSort(null);
                setSearchValue(null);
                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        } else {
            for (const [key, value] of Object.entries(lessonData)) {
                if (key === "instituteLessonName") {
                    for (const lesson of lessonData.instituteLessonName) {
                        if (lesson === '' || lesson.length === 0) {
                            setError((prevData) => ({
                                ...prevData,
                                instituteLessonName: 'This field is required.',
                            }));
                            break;
                        } else {
                            setError((prevData) => {
                                return {
                                    ...prevData,
                                    [key]: '',
                                }
                            });
                        }
                    }
                } else if (value == '') {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }

    const deleteLesson = async (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            try {
                setLoading(true);
                const apiUrl = `/delete-institute-lesson-master?id=${id}`;
                const response = await authorizedAxiosInstitute.delete(apiUrl);
                const page = deleteItem(currPage, itemsPerPage, lessonList.length);
                await getLessonList();
                setCurrPage(page);
                
                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        }
    }

    const updateLesson = async () => {
        try {
            setLoading(true);
            const apiUrl = `/edit-institute-lesson-master?id=${editId}`;
            const response = await authorizedAxiosInstitute.put(apiUrl, lessonData);
            await getLessonList();
            setEditId(null);
            setLessonData((prevData) => {
                return {
                    ...prevData,
                    instituteLessonName: [''],
                };
            })
            Swal.fire(
                { text: response.data.message }
            );
        } catch (error) {
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            Swal.fire(
                { text: errorMsg }
            );
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (syllabusNameSort == true || syllabusNameSort == false) {
            setSubjectNameSort(null);
            setLessonNameSort(null);
        }
    }, [syllabusNameSort])

    useEffect(() => {
        if (subjectNameSort == true || subjectNameSort == false) {
            setSyllabusNameSort(null);
            setLessonNameSort(null);
        }
    }, [subjectNameSort])

    useEffect(() => {
        if (lessonNameSort == true || lessonNameSort == false) {
            setSyllabusNameSort(null);
            setSubjectNameSort(null);
        }
    }, [lessonNameSort])

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <div id='scroll-up'></div>
                <Header />
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb my-0 ms-2">
                        <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/institute-dashboard')}>
                            <span>Dashboard</span>
                        </li>
                        <li className="breadcrumb-item active"><span>Institute Lesson Master</span></li>
                    </ol>
                </nav>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-file-circle-check"></i> Institute Lesson Master</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Syllabus Structure :</label>
                                                    <select class="form-select" aria-label="Default select example" name='instituteSyllabusStructureMasterId' onChange={handleSyllabusChange} value={lessonData.instituteSyllabusStructureMasterId}>
                                                        <option selected value={''} disabled>Select Syllabus</option>
                                                        {
                                                            syllabusList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus.instituteSyllabusStructureName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.instituteSyllabusStructureMasterId && <p style={{ color: 'red' }}>{error.instituteSyllabusStructureMasterId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                                                    <select class="form-select" aria-label="Default select example" name='instituteSubjectMasterId' onChange={handleInputChange} value={lessonData.instituteSubjectMasterId}>
                                                        <option selected value={''} disabled>Select Subject</option>
                                                        {
                                                            subjectList?.map((syllabus) => {
                                                                return <option value={syllabus.instituteSubjectMasterDetails.id}>{syllabus.instituteSubjectMasterDetails.subjectName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.instituteSubjectMasterId && <p style={{ color: 'red' }}>{error.instituteSubjectMasterId}</p>}
                                                </div>

                                                {lessonData?.instituteLessonName?.map((lesson, index) => (
                                                    <>
                                                        <div className="col-md-6">
                                                            <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Lesson Name :</label>
                                                            <input type="text" className="form-control" id={`instituteLessonName${index}`} name='instituteLessonName' onChange={(e) => handleInputChange(e, index)} value={lesson} />
                                                            {error.instituteLessonName && lesson == "" && <p style={{ color: 'red' }}>{error.instituteLessonName}</p>}
                                                        </div>
                                                        {lessonData.instituteLessonName.length > 1 && (
                                                            <div className="col-md-1 mt-4 mb-1" style={{ textAlign: 'right' }}>
                                                                <button className="btn btn-primary" type="button" style={{ marginTop: '14px' }} onClick={() => handleRemoveLesson(index)} ><i class="material-icons" style={{ fontSize: '20px' }} >delete</i></button>
                                                            </div>
                                                        )}
                                                    </>
                                                ))}

                                                {!editId && (
                                                    <div className="col-md-12 mt-4 mb-1">
                                                        <div className="col-auto">
                                                            <button className="btn btn-primary" type="button" style={{ width: '233px' }} onClick={handleAddLesson}>+ Add Another Lesson Name</button>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>

                                                    <div className="col-auto">
                                                        {!editId && <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} onClick={addLesson}>Save</button>
                                                        }
                                                        <button className="btn btn-outline-danger delete_icon" type="button" style={{ marginRight: '20px' }} onClick={() => { setLessonList([]); setEditId(''); setLessonData(initialFormState) }}>Reset</button>
                                                        {
                                                            editId && (<button className="btn btn-success approve_icon" type="button" onClick={updateLesson} disabled={!editId}>Update</button>)
                                                        }
                                                    </div>
                                                </div>

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">
                                                                            Syllabus Name
                                                                            <SortIcon sortState={syllabusNameSort} setSortState={setSyllabusNameSort} setData={setLessonList} setCurrPage={setCurrPage} sortingPath={"instituteSyllabusStructureMasterDetails.instituteSyllabusStructureName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Subject Name
                                                                            <SortIcon sortState={subjectNameSort} setSortState={setSubjectNameSort} setData={setLessonList} setCurrPage={setCurrPage} sortingPath={"instituteSubjectMasterDetails.subjectName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Lesson Name
                                                                            <SortIcon sortState={lessonNameSort} setSortState={setLessonNameSort} setData={setLessonList} setCurrPage={setCurrPage} sortingPath={"instituteLessonName"} />
                                                                        </th>
                                                                        <th scope="col">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData.length > 0 ?
                                                                            displayedData.map((lesson, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{lesson.instituteSyllabusStructureMasterDetails?.instituteSyllabusStructureName}</td>
                                                                                        <td>{lesson.instituteSubjectMasterDetails.subjectName}</td>

                                                                                        <td>{lesson.instituteLessonName}</td>
                                                                                        <td>
                                                                                            <button className="btn-outline-warning edit_icon" title='Coming Soon...' disabled type="button" onClick={() => {
                                                                                                setLessonData({
                                                                                                    instituteMasterId: instituteMasterId,
                                                                                                    instituteSyllabusStructureMasterId: lesson.instituteSyllabusStructureMasterDetails?.id,
                                                                                                    instituteLessonName: [lesson.instituteLessonName],
                                                                                                    instituteSubjectMasterId: lesson.instituteSubjectMasterDetails.id
                                                                                                });
                                                                                                setEditId(lesson.id);
                                                                                                document.getElementById('scroll-up').scrollIntoView({ behavior: 'smooth' });
                                                                                            }}><i class="fa-light fa-pen-to-square"></i></button>
                                                                                            <button className="btn-outline-danger delete_icon" title='Coming Soon...' disabled type="button" /*disabled={editId === lesson.id}*/ onClick={() => deleteLesson(lesson.id)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Lesson Available</th>

                                                                            </tr>)
                                                                    }

                                                                </tbody>
                                                            </table>
                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={lessonList.length} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default InstituteLessonMaster;